import { useState, useEffect } from "react";
import ClientService from "../services/ClientService";
import ClientLicenceService from "../services/ClientLicenceService";
import NotificationsService from "../services/NotificationsService";

const useGetDataPaginatedList = (
	dataType,
	initialPage,
	initialSearchText,
	initialColumnClicked,
	refreshKey,
) => {
	const [data, setData] = useState([]);
	const [columnClicked, setColumnClicked] = useState(initialColumnClicked);
	const [maxPage, setMaxPage] = useState(1);
	const [isLoading, setIsLoading] = useState(true);

	const getData = async (dataType, page, searchText, columnClicked) => {
		let response = [];
		setIsLoading(true);
		if (dataType === "clients") {
			response = await ClientService.listClientsPaginated(
				page,
				searchText,
				columnClicked,
			);
		}
		if (dataType === "licences") {
			response = await ClientLicenceService.listLicencesPaginated(
				page,
				searchText,
				columnClicked,
			);
		}
		if (dataType === "webhooks") {
			response = await NotificationsService.listWebhooks(
				page,
				searchText,
				columnClicked,
			);
		}
		setData(response.data.items);
		setMaxPage(response.data.meta?.totalPages ?? response.data.pagination?.totalPages);
		setIsLoading(false);
	};

	useEffect(() => {
		getData(dataType, initialPage, initialSearchText, columnClicked);
	}, [dataType, initialPage, initialSearchText, columnClicked, refreshKey]);

	return {
		data,
		columnClicked,
		maxPage,
		setColumnClicked,
		refetchData: getData,
		isLoading,
	};
};

export default useGetDataPaginatedList;
